/**
 * The group name that a product can be assigned. This can come from the
 * PIM or can be interpreted from the size string on a completed variant.
 */
export enum GroupName {
  Kids = 'kids',
  Men = 'men',
  Toddlers = 'toddlers',
  Unisex = 'unisex',
  AllGender = 'all-gender',
  Women = 'women',
  Youth = 'youth',
  BigKids = 'big-kids',
  Boys = 'boys',
  Girls = 'girls'
}

export const GENDER_MAP: Record<string, GroupName> = {
  W: GroupName.Women,
  M: GroupName.Men,
  T: GroupName.Toddlers,
  U: GroupName.Unisex,
  'M/W': GroupName.AllGender,
  K: GroupName.Kids,
  Y: GroupName.Youth
  // TODO: Figure out Big Kids, Boys, and Girls mapping
};
